// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import loadEvents from "@werner/App/Handlers/TrainingCalender/LoadEvents";
import { EventsCollectionModel, getEvents, GetEventsApiParameter } from "@werner/App/Services/EventService";
import { CustomAppState } from "@werner/App/Store/Reducers";

interface Props {
    apiParameter: any;
    apiResult: any;
}

type Parameter = {name:string, parent:string};

type HandlerType = Handler<Parameter, Props>;

export const DispatchBeginAction: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const DispatchSettingFilters: HandlerType = props => {
    props.dispatch({
        type: "TrainingCalender/SetEventFilters",
        parent: props.apiParameter.parent,
        name: props.apiParameter.name,
        parameter: props.parameter,
    } as any);
};

export const DispatchCompleteLoadFilteredTrainingCalenderEvents: HandlerType = props => {
    props.dispatch(loadEvents((props.getState() as CustomAppState).trainingCalender.selectedFilters));
};

export const chain = [DispatchBeginAction, DispatchSettingFilters, DispatchCompleteLoadFilteredTrainingCalenderEvents];

const setEventFilters = createHandlerChainRunner(chain, "setEventFiltersHandler");
export default setEventFilters;
